/**
 * Default: Vendors > OverlayScrollbars
 */

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

import {
	OverlayScrollbars,
	ClickScrollPlugin
} from 'OverlayScrollbars';

OverlayScrollbars.plugin(ClickScrollPlugin);

// -------
// Private
// -------



// ------
// Public
// ------

const init = async () => {
	const collection = SelectorEngine.find('[data-provider="overlayscrollbars"]');

	if (collection.length > 0) {
		for (const element of collection) {
			OverlayScrollbars(element, {
				scrollbars: {
					clickScroll: true,
					visibility : 'auto',
					autoHide   : 'never'
				}
			});
		}
	}
};

// Export
export default init;
